import type { CustomerStatus } from '../../interface/Status';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getCustomerStatus = async () => {
  try {
    const { data } = await api.get<CustomerStatus>(
      apiConfig.routes.customer.wallet.status
    );
    return data;
  } catch {
    return {
      isEqi: false,
      isEqiDigital: false,
      hasPrev: false,
      investorCategory: '',
      suitability: '',
    };
  }
};

export const useGetCustomerStatus = () => {
  const { data: session } = useSession();
  return useQuery({
    queryKey: ['customer', 'status', session?.user.document],
    queryFn: getCustomerStatus,
    enabled: !!session && !!session.access_token,
  });
};
